import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { calSubTotal } from "../../../../../../../../../store/Concept/actions";
import { Wrapper } from "./styled";
import { isSelected } from "../../../../../../../../../utils/functions";
import { selectedArticles } from "../../../../../../../../../store/Concept/selectors";
import { Text } from "../../../../styled";
import Tooltip from "@material-ui/core/Tooltip";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { theme } from "../muiStyled";

const SubTotal = ({ row }) => {
  const dispatch = useDispatch();
  const items = useSelector(selectedArticles);

  const getValue = () => {
    return `$ ${row.original.subtotal?.toFixed(2)}`;
  };

  useEffect(() => {
    dispatch(calSubTotal(row.original.id));
  }, []);

  if (row.canExpand) {
    return null;
  }

  return (
    <MuiThemeProvider theme={theme}>
      <Tooltip placement="right-start" title={getValue()}>
        <Wrapper>
          <Text canExpand={row.canExpand} isSelected={isSelected(items, row.original.id)}>
            {getValue()}
          </Text>
        </Wrapper>
      </Tooltip>
    </MuiThemeProvider>
  );
};

export default SubTotal;
